import { GlobalConfigService } from './../../../../../../services/global-config/global-config.service';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { BroadcastService, MibpLogger } from 'root/services';
import { Subscription } from 'rxjs';
import { DashboardLatestOrderVm } from 'root/mibp-openapi-gen/models';
import { LogService } from 'root/services/logservice';
import { HttpCancellactionService } from 'root/services/http-cancellation/http-cancellation.service';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { EcommerceRouterLinkDirective } from 'root/directives/ecommerce-router-link/ecommerce-router-link.directive';
import { FormatPricePipe } from 'root/pipes/format-price/format-price.pipe';
import { ordersFnGetDashboardLatestOrders } from "root/mibp-openapi-gen/fn/orders/orders-fn-get-dashboard-latest-orders";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  selector: "mibp-dashboard-latest-orders",
  templateUrl: "./dashboard-latest-orders.component.html",
  styleUrls: ["./dashboard-latest-orders.component.scss"],
  providers: [HttpCancellactionService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, LoaderComponent, EcommerceRouterLinkDirective, FormatPricePipe]
})
export class MibpDashboardLatestOrdersComponent implements OnInit, OnDestroy {
    private mibpApiService = inject(MibpApiService);
  private httpCancellation = inject(HttpCancellactionService);
  private broadcast = inject(BroadcastService);
  private globalConfig = inject(GlobalConfigService);
  orders: DashboardLatestOrderVm[];
  isLoading = false;
  hasError = false;
  actAsSub: Subscription;
  isDynamicdashboard = false;
  log: MibpLogger;

  constructor() {
    const logger = inject(LogService);

    this.log = logger.withPrefix(`dashboard-tile-latest-orders`);
  }

  async load(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.orders = await this.httpCancellation.singleValueFrom(
        this.mibpApiService.invoke(ordersFnGetDashboardLatestOrders)
      );
      this.isLoading = false;
    } catch (error) {
      this.log.error("error getting list of orders", error);
      this.hasError = true;
      this.isLoading = false;
    }
  }

  ngOnInit(): void {
    this.actAsSub = this.broadcast.deliverySequence.subscribe(() =>
      this.load()
    );
    this.isDynamicdashboard = this.globalConfig.activateDynamicDashboard;
  }

  ngOnDestroy(): void {
    this.actAsSub?.unsubscribe();
  }
}
